import React from "react";
import { HelpPanel } from "@cloudscape-design/components";
const ViewExplorerHelper = () => {
  return /* @__PURE__ */ React.createElement(HelpPanel, { header: /* @__PURE__ */ React.createElement("h2", null, "Explore Views") }, /* @__PURE__ */ React.createElement("p", null, "Select a View to see AWS Resources that match its definition"));
};
export default ViewExplorerHelper;
